import { render, staticRenderFns } from "./editAlarm.vue?vue&type=template&id=4c2e5242&"
import script from "./editAlarm.vue?vue&type=script&lang=js&"
export * from "./editAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports